// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BalloonBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 1.5A11.512 11.512 0 0 0 4.5 13c0 3.066 1.194 6.266 3.274 8.777 1.25 1.5 2.695 2.634 4.256 3.345l-1.405 3.287A1.5 1.5 0 0 0 12 30.5h8a1.5 1.5 0 0 0 1.375-2.091l-1.405-3.284c1.561-.711 3.01-1.841 4.256-3.345 2.08-2.514 3.274-5.714 3.274-8.78A11.513 11.513 0 0 0 16 1.5Zm1.725 26h-3.45l.669-1.561c.701.081 1.41.081 2.112 0l.669 1.561Zm4.191-7.636C20.241 21.886 18.14 23 16 23c-2.14 0-4.241-1.114-5.916-3.136C8.466 17.91 7.5 15.345 7.5 13a8.5 8.5 0 0 1 17 0c0 2.345-.966 4.911-2.584 6.864Zm-.792-5.875a1.5 1.5 0 0 1-1.641-1.344 3.5 3.5 0 0 0-2.434-2.989 1.5 1.5 0 0 1 .902-2.861 6.493 6.493 0 0 1 4.517 5.553 1.5 1.5 0 0 1-1.343 1.644l-.001-.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
